import i18n from '@/i18n'
import { notifyErrorMessage } from '@/utils/error'
import { logger } from '@/utils/logger'

export const notifyHttpStatusError = (
  status: number,
  fallbackMessage?: string,
  options?: { scope?: string },
) => {
  if (options?.scope) {
    logger.debug(`${options.scope} status error`, { status, fallbackMessage })
  }

  switch (status) {
    case 401:
      notifyErrorMessage(i18n.global.t('error.sessionExpired'))
      break
    case 403:
      notifyErrorMessage(i18n.global.t('error.noPermission'))
      break
    case 404:
      notifyErrorMessage(i18n.global.t('error.resourceNotFound'))
      break
    case 500:
      notifyErrorMessage(i18n.global.t('error.serverError'))
      break
    default:
      notifyErrorMessage(fallbackMessage || i18n.global.t('error.requestFailed'))
  }
}

export const notifyNetworkError = (scope?: string) => {
  if (scope) {
    logger.debug(`${scope} network error`)
  }
  notifyErrorMessage(i18n.global.t('error.networkError'))
}
